var orderJS = {
    data() {
        return {

        }
    },
    methods: {
        //节流
        buttonFlag(code) {
            if(!this[code]) {
                this.$vux.toast.text('请不要快速点击');
                return false;
            } else {
                this[code] = false;
                setTimeout(() => {
                    this[code] = true;
                }, 1500);
                return true;
            }
        },
        //取消订单
        cancleOrderFunc(one, callback) {
            let that = this;
            that.$vux.confirm.show({
                content: `确定要取消订单吗？`,
                cancelText: '取消',
                confirmText: '确定',
                title: '提示',
                onConfirm () {
                    var data = {
                        goodsOrderId: one.goodsOrderId,
                        status: one.status
                    }
                    that.$axios.post('/api/v1.0/lonbonShop/cancelOrder', that.qs.stringify(data)).then(function (response) {
                        if(response.status == 200) {
                            that.$vux.toast.text('已取消');
                            callback&&callback();
                        }
                    })
                }
            })
        },
        //删除订单
        deleteOrderFunc(one, callback) {
            let that = this;
            that.$vux.confirm.show({
                content: `确定要删除订单记录吗？`,
                cancelText: '取消',
                confirmText: '确定',
                title: '提示',
                onConfirm () {
                    var data = {
                        goodsOrderId: one.goodsOrderId,
                        status: one.status
                    }
                    that.$axios.post('/api/v1.0/lonbonShop/deleteOrder', that.qs.stringify(data)).then(function (response) {
                        if(response.status == 200) {
                            that.$vux.toast.text('已删除');
                            callback&&callback();
                        }
                    })
                }
            })
        },
        //查看物流
        loadLogistics(order) {
            this.$router.push("logistics?goodsOrderId="+order.goodsOrderId);
        },
        //确认收货
        sureTakeFunc(one, callback) {
            let that = this;
            that.$vux.confirm.show({
                content: `是否确认收货？`,
                cancelText: '取消',
                confirmText: '确定',
                title: '提示',
                onConfirm () {
                    var data = {
                        goodsOrderId: one.goodsOrderId,
                        status: one.status
                    }
                    that.$axios.post('/api/v1.0/lonbonShop/confirmReceipt', that.qs.stringify(data)).then(function (response) {
                        if(response.status == 200) {
                            that.$vux.toast.text('操作成功');
                            callback&&callback();
                        }
                    })
                }
            })
        }
    }
}

export default orderJS = orderJS;


// WEBPACK FOOTER //
// ./src/components/order/order.js